// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Bot_wrap__otyiW","button":"Bot_button__AZydb"};